import './CustomSignIn.scss';

import { Button } from '@rmwc/button';
import { TextField, TextFieldHelperText as HelperText } from '@rmwc/textfield';
import { Auth, JS } from 'aws-amplify';
import { SignIn } from 'aws-amplify-react';
import React from 'react';

class CustomSignIn extends SignIn {
    constructor(props) {
        super(props);

        this.state = {
            username: '',
            password: '',
        };
    }

    checkContact = user => {
        if (!Auth || typeof Auth.verifiedContact !== 'function') {
            throw new Error('No Auth module found, please ensure @aws-amplify/auth is imported');
        }
        Auth.verifiedContact(user).then(data => {
            if (!JS.isEmpty(data.verified)) {
                this.changeState('signedIn', user);
            } else {
                user = Object.assign(user, data);
                this.changeState('verifyContact', user);
            }
        });
    };

    signIn = () => {
        let { username, password } = this.state;

        username = username.toLowerCase();

        Auth.signIn(username, password)
            .then(user => {
                if (
                    user.challengeName === 'SMS_MFA' ||
                    user.challengeName === 'SOFTWARE_TOKEN_MFA'
                ) {
                    this.changeState('confirmSignIn', user);
                } else if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
                    this.changeState('requireNewPassword', user);
                } else if (user.challengeName === 'MFA_SETUP') {
                    this.changeState('TOTPSetup', user);
                } else {
                    this.checkContact(user);
                }

                this.props.history.push('/');
            })
            .catch(err => {
                if (err.code === 'UserNotConfirmedException') {
                    this.changeState('confirmSignUp');
                } else if (err.code === 'PasswordResetRequiredException') {
                    this.changeState('requireNewPassword');
                } else {
                    this.error(err);
                }
            });
    };

    handleChange = event => {
        const { name, value } = event.target;

        this.setState({ [name]: value });
    };

    handleSubmit = event => {
        event.preventDefault();
        this.signIn();
    };

    showComponent() {
        return (
            <div className="login-wrapper">
                <img src="/images/logo-large-en.png" alt="SmartAgent" />
                <div className="login-paper">
                    <form className="login-form" onSubmit={this.handleSubmit}>
                        <TextField
                            label="Email"
                            helpText={<HelperText>Enter your email</HelperText>}
                            outlined={true}
                            name="username"
                            id="username"
                            autoComplete="username"
                            onChange={this.handleChange}
                            value={this.state.username}
                        />
                        <TextField
                            label="Password"
                            helpText={<HelperText>Enter your password</HelperText>}
                            outlined={true}
                            name="password"
                            id="password"
                            type="password"
                            autoComplete="current-password"
                            onChange={this.handleChange}
                            value={this.state.password}
                        />
                        <Button
                            type="submit"
                            raised
                            className="login-button mdc-theme--primary-bg mdc-theme--on-primary"
                        >
                            Sign in
                        </Button>
                    </form>
                    <div className="forgot-wrapper">
                        Forgot your password?
                        <button
                            className="link-button"
                            onClick={() => this.changeState('forgotPassword')}
                        >
                            Reset password
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default CustomSignIn;
